import Hero from '../components/Hero'
import { useEffect, useState } from 'react'

const About = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true)
          }
        })
      },
      { threshold: 0.3 }
    )

    const aboutSection = document.getElementById('about-rmm')
    if (aboutSection) {
      observer.observe(aboutSection)
    }

    return () => {
      if (aboutSection) {
        observer.unobserve(aboutSection)
      }
    }
  }, [])

  return (
    <>
      {/* Hero */}
      <Hero 
        title="About Us"
        subtitle="Since 2018, we’ve been a trusted partner in delivering building and commercial property services, helping facilities of every size operate at their best."
        backgroundImage="/about/about.png"
        height="63.75vh"
      />

      {/* About Adept Services */}
      <section id="about-rmm" className="about-rmm-section">
        <div className="about-rmm-container">
          <div className="about-rmm-content">
            <div className="about-rmm-cards">
              <div className={`about-card ${isVisible ? 'animate-in' : ''}`} style={{ animationDelay: '0.2s' }}>
                <h3>Expertise & Advantage</h3>
                <p>At Adept Services, our experience across diverse industries has shaped specialised skills that give our clients a clear advantage, delivering solutions with greater knowledge, speed, and efficiency when tackling new operational challenges.</p>
              </div>
              
              <div className={`about-card ${isVisible ? 'animate-in' : ''}`} style={{ animationDelay: '0.4s' }}>
                <h3>National Reach, Local Flexibility</h3>
                <p>With national coverage, Adept Services is able to design service models tailored to each client's exact needs. This ensures flexibility, enhanced business performance, a single point of contact, convenience, and cost efficiencies.</p>
              </div>
              
              <div className={`about-card ${isVisible ? 'animate-in' : ''}`} style={{ animationDelay: '0.6s' }}>
                <h3>The Adept Accountability Framework</h3>
                <p>Adept Services' Accountability Framework is built on structured systems, robust processes, quality assurance, and industry accreditation. Created to ensure individual accountability, clear standards, and measurable outcomes, it defines the why, what, how, and resources required to consistently deliver the Adept Standard.</p>
              </div>
            </div>
            
            <div className="about-rmm-image">
              <img src="/about/adept_services_building.png" alt="Adept Services Building" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section id="mission" className="mission-values-section">
        <div className="mission-values-container">
          <div className="mission-values-header">
            <h2>Our Mission And Values</h2>
          </div>
          
          <div className="mission-statement">
            <p>Our mission is to be recognised as the industry benchmark by consistently delivering high-quality services, attracting the best people, and embracing innovation. True success is reflected in the trust, satisfaction, and long-term relationships we build with our clients.</p>
          </div>
          
          <div className="values-cards">
            {/* 1. Quality Assurance */}
            <div className="value-card">
              <div className="value-icon"><img src="/about/mission/quality_assurance.png" alt="quality assurance icon" /></div>
              <h3>Excellence Guaranteed</h3>
            </div>
            {/* 2. Environmental Responsibility */}
            <div className="value-card">
              <div className="value-icon"><img src="/about/mission/environmental.png" alt="environmental responsibility icon" /></div>
              <h3>Sustainable Practices</h3>
            </div>
            {/* 3. Innovation */}
            <div className="value-card">
              <div className="value-icon"><img src="/about/mission/innovation.png" alt="innovation icon" /></div>
              <h3>Continuous Improvement</h3>
            </div>
            {/* 4. Accountability */}
            <div className="value-card">
              <div className="value-icon"><img src="/about/mission/accountability.png" alt="accountability icon" /></div>
              <h3>Ownership & Transparency</h3>
            </div>
            {/* 5. Customer Focus */}
            <div className="value-card">
              <div className="value-icon"><img src="/about/mission/customer_focused.png" alt="Customer Focus icon" /></div>
              <h3>Commitment to Customers</h3>
            </div>
          </div>
          
          <div className="photographic-panels">
            <div className="photo-panel">
              <img src="/about/mission/our_team.png" alt="Our team" />
              <div className="photo-label">PEOPLE FIRST</div>
            </div>
            <div className="photo-panel">
              <img src="/about/mission/our_purpose.png" alt="Our Purpose" />
              <div className="photo-label">PURPOSE DRIVEN</div>
            </div>
            <div className="photo-panel">
              <img src="/about/mission/our_profit.png" alt="Our Profit" />
              <div className="photo-label">SUSTAINABLE SUCCESS</div>
            </div>
            <div className="photo-panel">
              <img src="/about/mission/our_planet.png" alt="Our Planet" />
              <div className="photo-label">PLANET PROTECTED</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <h2>Connect With Us</h2>
        <p>Ready to partner with a facility services provider committed to excellence? Reach out to discuss how we can support your needs.</p>
        <a className="cta-button" href="/contact">Contact Us</a>
      </section>
    </>
  )
}

export default About
